export default "__VITE_ASSET__ByvmksH1__"